<template>
  <div>
    <DashboardWidgetLayout :loading="isSavableStateLoading"
      widget-id="internal-qa-offers-dashboard-full"
      widget-title="QA Offers"
      :show-filter-panel="true"
      :widget-icon="['fas', 'user-group']">
      <template #filters>
        <form class="row">
          <div class="col-12">
            <div class="row">
              <SingleSelect v-model="dataParams.transplant_center_id"
                  name="transplant_center_id"
                  label="Transplant Center"
                  rules="required"
                  label-key="label"
                  value-key="value"
                  :options="internalQAStore.transplantCenters"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column"
                  @change="" />
              <div class="form-group-standard-column">
                <label class="form-label" for="month-selector">
                  Month <span class="text-danger">*</span>
                </label>
                <VueDatePicker v-model="dataParams.for_month"
                  name="vue-date-picker"
                  month-picker
                  :auto-apply="true"
                  :time-config="{ enableTimePicker: false }"
                  required />
              </div>
                <MultiSelectInput v-model="dataParams.organ_group_id"
                name="organ_group_id"
                label="Organ"
                label-key="label"
                value-key="value"
                :options="internalQAStore.organGroups"
                :filter="true"
                :show-clear="true"
                col-style="form-group-standard-column"
                multiple
                @change="" />
            </div>
          </div>
          <div class="col-12">
            <ActionToolbar :component-state="currentState" 
              :error-message="formError"  
              primary-button-text="Filter"
              secondary-button-text="Cancel"
              @primary-click="loadDashboardContent"
              @secondary-click="cancelClicked"
              :primary-disabled="!dataParams.transplant_center_id || !dataParams.for_month || isSavableStateProcessing">
              >
            </ActionToolbar>
          </div>
        </form>
      </template>
      <template #content>
        <div v-if="!internalQAStore.dashboardContent || !internalQAStore.dashboardContent.totalRows">
          No results found or no Transplant Center selected.
        </div>
        <template v-else>
          <form class="row" @submit.prevent>
            <div class="col-12">
              <div class="row">
                <div class="float-right ml-auto mr-2">
                  <span tooltip="Current View"><font-awesome-icon :icon="['fas', 'eye']" /><b>: {{ currentView }}</b></span>
                </div>
              </div>
              <div class="row">
                <MultiSelectInput v-model="filterParams.match_applicable_service_level"
                  name="match_applicable_service_level"
                  label="Service Level Applicable"
                  label-key="label"
                  value-key="value"
                  :options="availableServiceLevelApplicable"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column"
                  multiple
                  @change="" />
                <MultiSelectInput v-model="filterParams.match_service_level_error"
                  name="match_service_level_error"
                  label="Service Level Error"
                  label-key="label"
                  value-key="value"
                  :options="availableServiceLevelErrors"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column"
                  multiple
                  @change="" />
                <div class="form-group-standard-column">
                  <label>Match Code</label>
                  <input columnType="text" v-model="filterParams.match_code" class="form-control">
                </div>
                <div class="form-group-standard-column">
                  <label>Donor Code</label>
                  <input columnType="text" v-model="filterParams.donor_code" class="form-control">
                </div>
                <MultiSelectInput v-model="filterParams.offer_approval_type"
                  name="offer_approval_type"
                  label="Offer Approval Types"
                  :options="offerApprovalTypes"
                  label-key="label"
                  value-key="name"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column" 
                  multiple
                  @change="" />
                 <MultiSelectInput v-model="filterParams.match_final_disposition_applicable"
                  name="match_final_disposition_applicable"
                  label="Final Disposition Applicable"
                  label-key="label"
                  value-key="value"
                  :options="availableFinalDispositionApplicable"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column"
                  multiple
                  @change="" />
                 <MultiSelectInput v-model="filterParams.match_decline_physician"
                  name="match_decline_physician"
                  label="Match decline physician"
                  label-key="label"
                  value-key="value"
                  :options="availableMatchDeclinePhysician"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column"
                  multiple
                  @change="" />
                 <MultiSelectInput v-model="filterParams.match_auto_rule_out"
                  name="match_auto_rule_out"
                  label="Auto Rule Out"
                  label-key="label"
                  value-key="value"
                  :options="autoRuleOutOptions"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column"
                  multiple
                  @change="" />
                <MultiSelectInput v-model="filterParams.checklist_status"
                  v-if="appStore.currentUser.hasPermission('internal_match_checklists')"
                  name="checklist_status"
                  label="Checklist Status"
                  :options="[{ code: '', label: 'All' }, { code: 'not_started', label: 'Not Started' }, ...(internalQAStore.checklistStatuses || [])]"
                  label-key="label"
                  value-key="code"
                  :filter="true"
                  :show-clear="true"
                  col-style="form-group-standard-column"
                  multiple
                  @change="" />
                </div>
            </div>
            <div class="col-12">  
              <ActionToolbar :component-state="currentState" 
                :error-message="formError"  
                tertiary-enabled
                primary-button-text="Filter"
                secondary-button-text="Clear"
                tertiary-button-text="Save"
                @primary-click="filterData"
                @secondary-click="() => { clearFilters(); filterData(); }">
                <template #tertiary-button-area>
                  <div class="dropdown d-flex align-items-center">
                    <a href="#" @click.prevent="saveView(true)" class="btn btn-outline-primary mr-3">Create view</a>
                    <a v-if="currentView !== 'Default'" href="#" @click.prevent="saveView(false)" class="btn btn-outline-primary mr-3">Update view</a>
                    <a class="btn btn-secondary dropdown-toggle" @click.prevent href="#" role="button" data-toggle="dropdown" aria-expanded="false">
                      Views
                    </a>

                    <div class="dropdown-menu dropdown-menu-scrollable">
                      <div
                        v-for="name in Object.keys(savedViews).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))"
                        :key="name"
                        class="dropdown-item d-flex align-items-center justify-content-between view-dropdown-item">
                        <a href="#" @click.prevent="loadView(name)" class="flex-grow-1 view-name-link">{{ name }}</a>
                        <span class="view-actions ml-2">
                          <a href="#" title="Rename view" class="mr-2" @click.stop.prevent="renameView(name)">
                            <font-awesome-icon :icon="['fas', 'pen']" />
                          </a>
                          <a v-if="name !== currentView" href="#" title="Delete view" class="text-danger" @click.stop.prevent="deleteView(name)">
                            <font-awesome-icon :icon="['fas', 'trash']" />
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </ActionToolbar>
            </div>
          </form>
          <div class="row">
            <div class="col-12">
              <DataTable
                ref="internalQADashboardTable"
                show-gridlines
                reorderable-columns
                @column-reorder="onColReorder"
                @column-resize-end="onColReSize"
                :key="datatableKey"
                resizable-columns 
                columnResizeMode="expand"
                scrollHeight="70vh" 
                scrollable
                row-hover
                table-style="min-width: 50rem"
                :loading="isSavableStateProcessing" 
                edit-mode="cell"
                v-model:selection="selectedRows"
                :expandedRows="internalQAStore.failedRows"
                @update:expandedRows="val => internalQAStore.failedRows = val"
                :rowClass="internalQaRow.getRowClass"
                :value="paginatedContent">
                <template #header>
                  <div class="d-flex justify-content-between w-100 align-items-center">
                    <button class="btn btn-outline-primary d-inline-block" @click="toggleSelectMode">
                      <font-awesome-icon :icon="['fas', (bulkSelect ? 'edit' : 'pen')]" />
                      <span v-if="bulkSelect" style="padding-right: 0.5rem">Disable Select Mode</span>
                      <span v-else style="padding-right: 0.5rem">Enable Select Mode</span>
                    </button>
                     <button v-if="bulkSelect && selectedRows" class="btn btn-outline-primary d-inline-block ml-4" @click="clearSelectedRows" :disabled="selectedRows.length === 0">
                      <font-awesome-icon :icon="['fas', 'square-check']" />
                      <span style="padding-right: 0.5rem">Clear Selection</span>
                    </button>

                    <span class="d-flex m-auto align-items-center px-3 flex-wrap">
                      Records Found: <span class="font-emphasize">{{ internalQAStore.visibleContent.length }}</span> |  Showing: <span class="font-emphasize ">{{ paginationRange }}</span> |  Offers pending approval: <span class="font-emphasize ">{{ offersPendingApprovalCount }}</span>
                    </span>

                    <button class="btn btn-outline-info d-inline-block" label="Export" @click="exportCSV($event)" :disabled="isExporting">
                      <span v-if="isExporting" class="spinner-border spinner-border-sm mr-1"></span>
                      Export CSV
                    </button>
                    <button class="btn btn-outline-dark d-inline-block ml-3" href="" @click.prevent="showManageColumns = !showManageColumns">
                      <font-awesome-icon :icon="['fas', 'caret-up']" v-if="showManageColumns" />
                      <font-awesome-icon :icon="['fas', 'caret-down']" v-else />
                        <span>Manage columns</span>
                    </button>
                    
                  </div>
                  <ColumnConfig :tableColumns="dashboardColumns" @configSaved="updateDashboardColumns" v-if="showManageColumns"></ColumnConfig>
                </template>
                <Column selection-mode="multiple" 
                  :frozen="true"
                  align-frozen="left"
                  header-style="width: 3rem" 
                  v-if="bulkSelect" />
                <Column v-for="(col, idx) in visibleTableColumns" 
                  :key="idx"
                  :field="col.field" 
                  align-frozen="left"
                  :frozen="col.isFrozen" 
                  :style="col.width && !col.wasResized ? `min-width: ${col.width};` : ''"                  
                  :header="col.header">
                  <template #body="{ data, index }">
                    <component
                      v-if="col.editable"
                      :disabled="data.donor.processing_status === 'ongoing' || bulkSelect"
                      :is="col.editorComponent"
                      :modelValue="internalQaRow.getNestedValue(data,col.field)"
                      @update:modelValue="val => internalQaRow.onModelValueUpdate(data, data.id, col, val)"
                      v-bind="col.editorProps"
                      :placeholder="col.placeholder"
                    />
                    <template v-else>
                      <span class="p-col-span" :class="{ 'column-prevent-wrap': col.identifier === 'match_donor_code', 'column-date-wrap': col.identifier === 'match_offer_date'}">
                      <font-awesome-icon v-if="col.statusIcon && col.identifier === 'match_donor_code' && donorStatus(data) == 'successful'" :icon="['fas', 'circle-check']" style="color: green;" title="Successful"/>
                      <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'match_donor_code' && donorStatus(data) == 'errored'" :icon="['fas', 'circle-exclamation']" style="color: red;" title="Errored"/>
                      <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'match_donor_code' && donorStatus(data) == 'ongoing'" :icon="['fas', 'spinner']" style="color: blue;" title="On going"/>
                      <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'match_calculated_final_disposition_code_applicable' && !data.final_disposition_approved" :icon="['fas', 'asterisk']" style="color: red;" title="Not approved"/>
                      <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'service_level_applicable' && !data.service_level_approved" :icon="['fas', 'asterisk']" style="color: red;" title="Not approved"/>
                      <span v-if="col.statusIcon" style="padding:2px !important;"></span>{{internalQaRow.getNestedValue(data,col.field)}}
                      </span>
                    </template>
                  </template>
                </Column>
                <Column class="btn-4-icon-group" :frozen="true"  align-frozen="right">
                  <template #body="slotProps">
                    <div class="d-flex">
                      <button href="#" title="Save" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="onSaveRow(slotProps.data)" :disabled="isActionDisabled(slotProps.data)">
                        <font-awesome-icon class="desktop-action" :icon="['fas', 'check']" style="color: green;"/><span class="mobile-action">Save</span>
                      </button >
      
                      <button href="#" title="Cancel" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="resetRow(slotProps.data.id)" :disabled="isActionDisabled(slotProps.data)">
                        <font-awesome-icon class="desktop-action" :icon="['fas', 'xmark']"  style="color: red;"/><span class="mobile-action">Cancel</span>
                      </button>
                      <button href="#" title="Refresh" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="internalQAStore.onRefreshRow(slotProps.data.id, filterParams)">
                        <font-awesome-icon class="desktop-action" :icon="['fas', 'rotate-right']"  style="color: blue;"/><span class="mobile-action">Refresh</span>
                      </button>

                      <button type="button" class="btn btn-outline-primary" @click="openPopup($event, slotProps.data)">
                        <font-awesome-icon :icon="['fas', 'caret-down']" />
                        <span class="sr-only">click to select</span>
                      </button>
                    </div>
                  </template>
                </Column>

                <!-- Row expansion slot -->
                <template #expansion="{ data }">
                  <div class="qa-error-box" v-if="data.current_state === SaveStates.Errored">
                    {{ data.errors }}
                  </div>
                </template>
                <template #footer v-if="bulkSelect" >       
                  <button href="#" :disabled="selectedRows.length === 0" @click.prevent="serviceLevelApprovals()" class="btn btn-success mr-3">Approve Service Level</button>
                  <button href="#" :disabled="selectedRows.length === 0" @click.prevent="serviceLevelUnApprovals()" class="btn btn-outline-danger mr-4">Unapprove Service Level</button>

                  <button href="#" :disabled="selectedRows.length === 0" @click.prevent="saveFinalDispositionApprovals()" class="btn btn-success ml-4">Approve FD</button>
                  <button href="#" :disabled="selectedRows.length === 0" @click.prevent="saveFinalDispositionUnApprovals()" class="btn btn-outline-danger ml-3">Unapprove FD</button>
                </template>
              </DataTable>
            
            <Pagination 
              v-if="totalPages > 1"
              :current_page="currentPage" 
              :page_count="totalPages"
              :disabled="isSaving"
              @updatePage="setPage" />
            </div>
          </div>

          <!-- The Popover component is placed outside the data table -->
          <Popover id="dashboard-plugin-dropdown" ref="qaDashboardPluginDropdown">
            <div>
              <button
                :disabled="donorStatus(selectedItem) == 'ongoing'"
                class="dropdown-item"
                autofocus
                type="button"
                @click="showModalFor(selectedItem, ActionModals.NOTES)">
                Coordinator Notes
              </button>
              <router-link
                v-if="appStore.currentUser.hasPermission('internal_match_checklists')"
                class="dropdown-item"
                target="_blank"
                :to="{ name: 'internal-match-checklists', params: { match_id: selectedItem.id } }">
                Checklists
                <font-awesome-icon :icon="['fas', 'up-right-from-square']" />
              </router-link>
            </div>
          </Popover>
        </template>
      </template>
    </DashboardWidgetLayout>
    <!-- Render modal component dynamically -->
    <component :is="requestedModal" 
      v-if="requestedModal" 
      :ref="requestedModal"
      :match-id="selectedMatch && selectedMatch.id"
      :donor-id="selectedMatch && selectedMatch.donor.id"
      @close="modalClosed()" 
      @note-updated="internalQAStore.onRefreshRow(selectedMatch.id, filterParams)"/>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';
import DataTable, { DataTableRowReorderEvent } from 'primevue/datatable';
import Column from 'primevue/column';
import DashboardWidgetLayout from "@/src/components/shared/DashboardWidgetLayout.vue";
import {useAppCoreStore, useDashboardsInternalQAStore} from "@/src/stores";
import { VueDatePicker } from '@vuepic/vue-datepicker';
import MultiSelectInput from "@/src/components/shared/FormComponents/MultiSelectInput.vue";
import SingleSelect from "@/src/components/shared/FormComponents/SingleSelect.vue";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import { TableColumn } from "@/src/models/dashboard/table-column";
import ColumnConfig from './ColumnConfig.vue';
import ActionToolbar from '@/src/components/shared/ActionToolbar.vue';
import {SaveStates} from "@/src/enums";
import { InternalQARow } from '@/src/models/dashboard/internal-qa-row';
import {format} from "date-fns-tz";
import Pagination from '@/src/components/shared/Pagination.vue';
import NotesModal from "@/src/components/buckeye-coordinator-area/modals/CoordinatorNotesModal.vue";
import Popover from 'primevue/popover';

const ActionModals = {
  NOTES: 'notes-modal'
}

export default {
  components: {
    NotesModal,
    ActionToolbar,
    DataTable,
    DashboardWidgetLayout,
    Column,
    VueDatePicker,
    SingleSelect,
    MultiSelectInput,
    ColumnConfig,
    Pagination,
    Popover
  },
  setup() {
    const appStore = useAppCoreStore();
    const internalQAStore = useDashboardsInternalQAStore();
    return {
      appStore,
      internalQAStore
    }
  },
  mixins: [savableStateMixin],
  data() {
    return {
      ActionModals,
      requestedModal: null,
      csrfToken: $("meta[name='csrf-token']").attr("content"),
      rowData: null,
      showManageColumns: false,
      organGroups: [],
      datatableKey: 'initial-key',
      currentPage: 1,
      itemsPerPage: 50,
      isSaving: false,
      isExporting: false,
      dataParams: {
        transplant_center_id: null,
        for_month: null,
        organ_group_id: null
      },
      filterParams: {
        match_applicable_service_level: null,
        match_service_level_error: null,
        match_final_disposition_applicable: null,
        match_decline_physician: null,
        match_auto_rule_out: null,
        match_code: null,
        donor_code: null,
        dcd: null,
        offer_approval_type: null,
        checklist_status: null
      },
      availableServiceLevelApplicable: [],
      availableServiceLevelErrors: [],
      availableFinalDispositionApplicable: [],
      availableMatchDeclinePhysician: [],
      autoRuleOutOptions: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      dashboardColumns: [],
      internalQaRow: new InternalQARow,
      currentView: 'Default',
      savedViews: {}, //TODO: Define a class for this
      bulkSelect: false,
      selectedRows: [],
      selectedMatch: null,
      offerApprovalTypes: [
        { name: 'fd_approved', label: 'Final dispositions - Approved' },
        { name: 'fd_unapproved', label: 'Final dispositions - Unapproved' },
        { name: 'sl_approved', label: 'Service Level - Approved' },
        { name: 'sl_unapproved', label: 'Service Level - Unapproved' }
      ],
      selectedItem: null
    }
  },
  async mounted() {
    this.appStore.setAppBreadcrumbs([
      {
        to: { name: 'internal-dashboards-root' },
        text: 'Dashboards'
      },
      {
        text: 'QA Dashboard'
      }
    ]);
    
    try {
      this.setSavableStateLoading();
      await this.internalQAStore.loadLookups();
      this.savedViews = await this.internalQAStore.loadViews();

      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error);
    }
    // Attach column resizer drag listener after mount
    this.$nextTick(() => {
      this.setupColumnResizerDragListener();
    });
  },
  beforeUnmount() {
    // Reset all relevant state to initial values
    this.dashboardColumns = [];
    this.internalQAStore.visibleContent = [];
    this.internalQAStore.dashboardContent = [];
    this.currentView = 'Default';
    this.dataParams = {
      transplant_center_id: null,
      for_month: null,
      organ_group_id: null
    };
    this.filterParams = {
      match_applicable_service_level: null,
      match_service_level_error: null,
      match_final_disposition_applicable: null,
      match_decline_physician: null,
      match_auto_rule_out: null,
      match_code: null,
      donor_code: null,
      dcd: null,
      offer_approval_type: null,
      checklist_status: null
    };
    this.showManageColumns = false;
  },
  watch: {
    datatableKey() {
      // Re-attach listener when table is re-rendered
      this.$nextTick(() => {
        this.setupColumnResizerDragListener();
      });
    }
  },
  computed: {
    visibleTableColumns() {
      return this.dashboardColumns.filter((c: TableColumn) => {
        return c.isVisible;
      });
    },

    totalPages() {
      return Math.ceil(this.internalQAStore.visibleContent.length / this.itemsPerPage);
    },
    
    paginatedContent() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.internalQAStore.visibleContent.slice(start, end);
    },

    paginationRange() {
      if (this.internalQAStore.visibleContent.length === 0) {
        return '0';
      }
      
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(this.currentPage * this.itemsPerPage, this.internalQAStore.visibleContent.length);
      
      if (start === end) {
        return `${start}`;
      }
      
      return `${start}-${end}`;
    },

    generateCSVFilename() {
      return `QaDashboard - ${new Date().toISOString()}`
    },
    offersPendingApprovalCount() {
      const approvedOffers = this.internalQAStore.visibleContent.filter(item => item.final_disposition_approved);
      return  this.internalQAStore.visibleContent.length - approvedOffers.length;
    }
  },
  methods: {
    extractUniqueOptions(records, fieldPath) {
      if (!Array.isArray(records) || !fieldPath) return [];

      const keys = fieldPath.split(".");
      const seen = new Set();

      return records.reduce((acc, record) => {
        const value = keys.reduce((obj, key) => obj?.[key], record);

        if (value && !seen.has(value)) {
          seen.add(value);
          acc.push({ label: value, value });
        }

        return acc;
      }, []);
    },
    calculateDynamicFilterOptions() {
      const blancOption = { 
        label: 'BLANK', 
        value: 'BLANK' 
      };

      const records = this.internalQAStore.dashboardContent?.rows || [];

      this.availableServiceLevelApplicable = this.extractUniqueOptions(
        records,"calculated_stats.applicable_service_level"
      );

      this.availableServiceLevelErrors = this.extractUniqueOptions(
        records,"calculated_stats.service_level_error"
      );

      this.availableFinalDispositionApplicable = this.extractUniqueOptions(
        records,"calculated_stats.final_disposition_applicable.code"
      );

      this.availableMatchDeclinePhysician = [
        blancOption,
        ...this.extractUniqueOptions(records, "physician")
      ];
    },
    showModalFor(match, modalType) {
      this.selectedMatch = match
      this.requestedModal = modalType;
      this.$refs.qaDashboardPluginDropdown.hide();
      this.$nextTick(() => {
        let modal = this.$refs[modalType];
        if(!modal) {
          alert(`No modal found for ${modalType}`);
          return;
        }
        modal.showModal();
      });
    },
    modalClosed() {
      this.selectedMatch = null;
    },
    exportCSV() {
      const checkboxColumns = new Set([
        'match_case_created',
        'match_auto_rule_out'
      ]);

      this.isExporting = true;
      
      try {
        const data = this.internalQAStore.visibleContent;

        if (!data.length) {
          alert('No data to export');
          return;
        }

        // Transform data 
        const exportData = data.map(row => {
          const csvRow = {};
          this.visibleTableColumns.forEach(col => {
            let value = this.internalQaRow.getNestedValue(row, col.field);

            // Use identifiers to determine if boolean so we can make effective YES/NO values
            if (checkboxColumns.has(col.identifier)) {
              value = value ? 'YES' : 'NO';
            }

            // Dropdowns with code mappings
            const codeMappings = {
              match_calculated_final_disposition_code_override: this.internalQAStore.finalDispositionCodes,
              donor_non_recovery_code: this.internalQAStore.nonRecoveries
            };
            if (codeMappings[col.identifier]) {
              const obj = Object.values(codeMappings[col.identifier]).find(o => o && o['value'] === value);
              value = obj ? obj['label'] : value;
            }

            // Assign value to CSV row
            csvRow[col.header || col.identifier] = value != null ? value : '';

          });
          return csvRow;
        });

        const csv = this.generateCSV(exportData);
        const filename = `QaDashboard - ${new Date().toISOString()}.csv`;
        this.downloadCSV(csv, filename);
        
      } catch (error) {
        console.error('Export failed:', error);
        alert('Export failed. Please try again.');
      } finally {
        this.isExporting = false;
      }
    },

    generateCSV(data) {
      if (!data || data.length === 0) return '';
      const headers = Object.keys(data[0]);
      
      // CSV headers
      const csvHeaders = headers.map(header => this.cleanCSVField(header)).join(',');
      
      // CSV rows
      const csvRows = data.map(row => {
        return headers.map(header => {
          const value = row[header];
          return this.cleanCSVField(value);
        }).join(',');
      });

      return [csvHeaders, ...csvRows].join('\n');
    },

    cleanCSVField(field) {
      if (field === null || field === undefined) {
        return '';
      }
      let value = String(field);
      value = value.replace(/"/g, '""'); // escape double quotes

      // Wrap in quotes for special characters
      if (value.includes(',') || 
          value.includes('"') || 
          value.includes('\n') || 
          value.includes('\r') || 
          value.trim() !== value) {
        value = `"${value}"`;
      }

      return value;
    },
    reloadRowData() {
      this.loadDashboardContent();
    },
    downloadCSV(csvContent, filename) {
      const BOM = '\uFEFF'; // excel compatibility
      const csvWithBOM = BOM + csvContent;
      
      const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      URL.revokeObjectURL(url);
    },

    setPage(page: number) {
      // Block pagination while saving
      if (this.isSaving) {
        return;
      }
      
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.scrollTableToTop();
      }
    },

    scrollTableToTop() {
      this.$nextTick(() => {
        const table = this.$refs.internalQADashboardTable?.$el;
        if (table) {
          const scrollableContainer = table.querySelector('.p-datatable-table-container')
          if (scrollableContainer) {
            scrollableContainer.scrollTop = 0;
          }
        }
      });
    },
    
    resetPagination() {
      this.currentPage = 1;
    },

    onSaveRow(data) {
      this.isSaving = true;
      return this.internalQAStore.onSaveRow(data, this.filterParams)
        .finally(() => {
          this.isSaving = false;
        });
    },
    
    resetRow(id: string) {
      this.internalQAStore.resetRow(id);
    },

    async getRowData() {
      try {
        await this.internalQAStore.loadDashboardData(this.dataParams);
        this.dashboardColumns = TableColumn.getProcessedDashboardColumns();        
      } catch(error) {
        console.log(error);
      }
    },
    async loadDashboardContent() {
      try {
        this.clearFilters();
        this.setSavableStateProcessing();
        await this.getRowData();
        this.calculateDynamicFilterOptions(); 
        this.currentView = 'Default'
        this.resetPagination(); // Reset to first page when loading new data
        
        this.setSavableStateIdle();
      } catch(error) {
        this.handleFormError(error);
      }
    },
    updateDashboardColumns(updatedColumns: Array<TableColumn>) {
      this.dashboardColumns = updatedColumns;
    },
    filterData() {
      // Strip whitespace from all string filter params
      const cleanedParams = { ...this.filterParams };
      Object.keys(cleanedParams).forEach(key => {
      if (typeof cleanedParams[key] === 'string') {
        cleanedParams[key] = cleanedParams[key].trim();
      }
      });
      this.internalQAStore.applySort(cleanedParams);
      this.resetPagination(); // Reset to first page when filtering
    },
    onColReorder(evt: DataTableRowReorderEvent) {      
      // Get only visible columns for reordering
      const visibleColumns = this.dashboardColumns.filter(c => c.isVisible);

      // Scroll position handling
      const table = this.$refs.internalQADashboardTable?.$el;
      const scrollable = table.querySelector('.p-datatable-table-container');
      const currentScrollLeft = parseInt(scrollable?.scrollLeft?.toString() || '0', 10);
      const resetScrollPosition = () => {
        this.$nextTick(() => {
          // Reset the scrollLeft to the current position to avoid jumping
          const table = this.$refs.internalQADashboardTable?.$el; // must redefine table to work
          const scrollable = table.querySelector('.p-datatable-table-container');
          if (scrollable) {
            scrollable.scrollLeft = currentScrollLeft;
          }
        });
      };

      // If moving the frozen column.
      if (evt.dragIndex > visibleColumns.length - 1) {
        this.forceRerenderTable()
        resetScrollPosition();
        return;
      }

      const movedColumn = visibleColumns[evt.dragIndex];
      if (!movedColumn) { // sanity check
        this.forceRerenderTable();
        return;
      }
      
      // Move the column in the visible columns array
      const reorderedVisibleColumns = [...visibleColumns];
      reorderedVisibleColumns.splice(evt.dragIndex, 1);
      reorderedVisibleColumns.splice(evt.dropIndex, 0, movedColumn);

      // Make a list of visible column positions
      const visiblePositions: number[] = [];
      this.dashboardColumns.forEach((col, idx) => {
        if (col.isVisible) {
          visiblePositions.push(idx);
        }
      });
      
      // Create a new array that preserves hidden column positions
      const newDashboardColumns = [...this.dashboardColumns];
      reorderedVisibleColumns.forEach((col, idx) => {
        const positionIndex = visiblePositions[idx];
        newDashboardColumns[positionIndex] = col;
        col.position = positionIndex;
      });
      
      this.dashboardColumns = newDashboardColumns;
      
      this.forceRerenderTable();
      resetScrollPosition();

    },
    onColReSize(event) {
      const delta = event.delta;
      const th = event.element as HTMLTableCellElement;

      const thText = th.innerText.trim();
      const colIdx = this.dashboardColumns.findIndex(col => col.header && col.header.trim() === thText);
      if (colIdx !== -1) {
        let currentWidth = parseInt(this.dashboardColumns[colIdx].width, 10);
        let newWidth = isNaN(currentWidth) ? th.offsetWidth : Math.round(currentWidth + delta)
        this.dashboardColumns[colIdx].width = `${newWidth}px`;
        
        this.dashboardColumns[colIdx].wasResized = true;
      }
    },
    isActionDisabled(data) {
      return !data.dirty;
    },
    donorStatus(data) {
      return data.donor.processing_status;
    },
    clearFilters() {
      this.filterParams = {
        match_applicable_service_level: null,
        match_service_level_error: null,
        match_final_disposition_applicable: null,
        match_decline_physician: null,
        match_auto_rule_out: null,
        match_code: null,
        donor_code: null,
        dcd: null,
        offer_approval_type: null,
        checklist_status: null
      };
    },
    cancelClicked() {
      this.dataParams= {
        transplant_center_id: null,
        for_month: null,
        organ_group_id: null
      };
      this.clearFilters();
      this.internalQAStore.visibleContent = [];
      this.internalQAStore.dashboardContent = [];
    },
    async saveView(forceNew = false) {
      let viewName;
      if (forceNew || this.currentView == 'Default') {
        viewName = prompt('Give the view a name');
        if (!viewName) {
          alert('You must provide a name!');
          return;
        } else if (this.savedViews[viewName]) {
          alert(`A view with the name "${viewName}" already exists! Please choose a different name.`);
          return;
        } 
      } else {
        viewName = this.currentView;
        if (!confirm(`Are you sure you want to update view: ${viewName}?`)) {
          this.setSavableStateIdle();
          return;
        }
      }
      this.savedViews[viewName] = {
        filterParams: { ...this.filterParams },
        
        // only the required user ui properties.
        dashboardColumns: this.dashboardColumns.map(col => ({
          identifier: col.identifier,
          position: col.position,
          width: col.width,
          isFrozen: col.isFrozen,
          isVisible: col.isVisible
        }))
      };
      try {
        this.setSavableStateProcessing();
        await this.internalQAStore.saveView(this.savedViews, viewName);
        this.currentView = viewName;
        this.setSavableStateIdle();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async deleteView(viewName: string) {
      if (!viewName || !this.savedViews[viewName]) return;
      if (viewName === this.currentView) return;
      if (!confirm(`Are you sure you want to delete view: ${viewName}?`)) return;

      try {
        this.setSavableStateProcessing();
        await this.internalQAStore.deleteView(viewName);
        this.savedViews = await this.internalQAStore.loadViews();
        this.setSavableStateIdle();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async renameView(viewName: string) {
      if (!viewName || !this.savedViews[viewName]) return;

      const newName = prompt(`Rename view "${viewName}" to:`, viewName);
      if (newName === null) return;
      const trimmed = newName.trim();
      if (!trimmed) {
        alert('You must provide a name!');
        return;
      }
      if (trimmed === viewName) return;
      if (this.savedViews[trimmed]) {
        alert(`A view with the name "${trimmed}" already exists! Please choose a different name.`);
        return;
      }

      try {
        this.setSavableStateProcessing();
        await this.internalQAStore.renameView(viewName, trimmed);
        if (this.currentView === viewName) this.currentView = trimmed;
        this.savedViews = await this.internalQAStore.loadViews();
        this.setSavableStateIdle();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async loadView(viewName: string) {
      if(!viewName || !this.savedViews[viewName]) return; // Nothing to do
      this.setSavableStateProcessing();
      const view = this.savedViews[viewName];
      this.currentView = viewName;
      this.clearFilters();
      
      for(const k in view.filterParams) {
        if(this.filterParams[k]) {
          this.filterParams[k].value = view.filterParams[k];
        } else {
          this.filterParams[k] = view.filterParams[k];
        }
      }
      
      // Load the dashboard columns from the view and compare with current dashboardColumns.
      const uiPreferencesDefaults = {
        position: undefined,
        width: undefined,
        isFrozen: false,
        isVisible: true,
        wasResized: false,
      };
      const loadedDashboardColumns = view.dashboardColumns.map((colFromView) => {
        const currentCol = this.dashboardColumns.find(c => c.identifier === colFromView.identifier) || {};

        // Start with all currentCol properties, reset the defaults, then merge from view
        const mergedCol = { ...currentCol, ...uiPreferencesDefaults };
        Object.keys(uiPreferencesDefaults).forEach(key => {
          if (colFromView.hasOwnProperty(key)) {
            mergedCol[key] = colFromView[key];
          }
        });
        mergedCol.identifier = colFromView.identifier;

        return new TableColumn(mergedCol);
      });

      // 1. Loaded columns by identifier
      const loadedColMap = Object.fromEntries(loadedDashboardColumns.map(col => [col.identifier, col]));

      // 2. Find the largest position value
      let maxPosition = loadedDashboardColumns.reduce((max, col) => (typeof col.position === 'number' && col.position > max ? col.position : max), -1);

      // 3. Add new qa dashboard columns that are not in the view.
      this.dashboardColumns.forEach(col => {
        if (!loadedColMap[col.identifier]) {
          const newCol = new TableColumn({ ...col, position: ++maxPosition, isVisible: false });
          loadedDashboardColumns.push(newCol);
        }
      });

      // 4. Remove columns from the view that no longer exist.
      const currentIdentifiers = new Set(this.dashboardColumns.map(col => col.identifier));
      for (let i = loadedDashboardColumns.length - 1; i >= 0; i--) {
        if (!currentIdentifiers.has(loadedDashboardColumns[i].identifier)) {
          loadedDashboardColumns.splice(i, 1);
        }
      }

      // 5. Sort and normalize positions
      loadedDashboardColumns.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
      loadedDashboardColumns.forEach((col, idx) => {
        col.position = idx;
      });

      this.dashboardColumns = loadedDashboardColumns;
  
      this.filterData();
      this.resetPagination(); // Reset to first page when loading view
      this.setSavableStateIdle();
      this.forceRerenderTable();
    },

    // Setup a column resizer drag listener for column width resizing
    setupColumnResizerDragListener() {
      const table = this.$refs.internalQADashboardTable?.$el;
      if (!table) return;
      const resizers = table.querySelectorAll('.p-datatable-column-resizer');
      resizers.forEach(resizer => {
        resizer.onpointerdown = null;
        resizer.addEventListener('pointerdown', this.onColumnResizerPointerDown, { passive: false });
      });
    },
    onColumnResizerPointerDown(e) {
      if (e.button !== 0) return;
      const resizer = e.target;

      // on dragging
      const onPointerMove = (e) => {
        this.onColumnResizeDragging(resizer);
      };
      const onPointerUp = () => {
        // remove listeners after dragging
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
      };

      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
    },
    onColumnResizeDragging(resizer) {
      // Remove the min-width style to allow resizing
      const th = resizer.closest('th');
      if (th && th.style) {
        th.style.minWidth = '';
      }
    },
    forceRerenderTable() {
      this.dashboardColumns.forEach(col => {
        col.wasResized = false; // Reset the resize flag
      });
      // Force re-render the table by changing the key
      this.datatableKey = `${new Date()}`;
    },
    async saveFinalDispositionApprovals() {
      const payload =  this.selectedRows.map(item => ({
        id: item.id,
        approved: true
      }))

      try {
        this.setSavableStateProcessing();
        await this.internalQAStore.saveFinalDispositionApprovals(payload);
        this.selectedRows = [];
        this.setSavableStateSuccess();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async saveFinalDispositionUnApprovals() {
      const payload = this.selectedRows.map(item => ({
        id: item.id,
        approved: false
      }))
      
      try {
        this.setSavableStateProcessing();
        await this.internalQAStore.saveFinalDispositionApprovals(payload);
        this.selectedRows = [];
        this.setSavableStateSuccess();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async serviceLevelApprovals() {
      const payload =  this.selectedRows.map(item => ({
        id: item.id,
        approved: true
      }))

      try {
        this.setSavableStateProcessing();
        await this.internalQAStore.saveServiceLevelApprovals(payload);
        this.selectedRows = [];
        this.setSavableStateSuccess();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async serviceLevelUnApprovals() {
      const payload = this.selectedRows.map(item => ({
        id: item.id,
        approved: false
      }))
      
      try {
        this.setSavableStateProcessing();
        await this.internalQAStore.saveServiceLevelApprovals(payload);
        this.selectedRows = [];
        this.setSavableStateSuccess();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async toggleSelectMode() {
      this.bulkSelect = !this.bulkSelect;
      this.selectedRows = [];
    },
    clearSelectedRows() {
      this.selectedRows = [];
    },
    openPopup(event, data) {
      this.$refs.qaDashboardPluginDropdown.toggle(event); // Call toggle method on the single Popover instance, using the current event as target
      this.selectedItem = data; // Update the popover content data
    },
  }
}
</script>
<style>
.p-select-dropdown-extend {
  justify-content: normal;
  width: 150px;
}
.row-edited {
  background-color: #fffbe6 !important; /* yellow for unsaved changes */
}

.row-saved {
  animation: fadeHighlight 2s forwards;
  background-color: #d4edda !important; /* green success background */
}

.row-saving {
  background-color: #f0f0f0 !important;
  pointer-events: none;
  opacity: 0.6;
}

.row-failed {
  background-color: #f8d7da !important;
  color: #721c24;
}

.qa-error-box {
  padding: 1rem;
  border-left: 4px solid #f87171;
  background-color: #fef2f2;    
  color: #b91c1c;                 
  font-size: 0.95rem;
}

.p-datatable-resizable-table > .p-datatable-tbody > tr > td:not(:has(> span.column-prevent-wrap)) {
  white-space: pre-wrap !important;
}

.p-datatable-resizable-table > .p-datatable-tbody > tr > td span.p-col-span {
  padding: 0 !important;
}
 
.p-datatable-resizable-table > .p-datatable-tbody > tr > td .p-select {
  width: 100%;
}


.column-prevent-wrap {
  padding: 0;
}

.column-date-wrap {
  display: block;
  width: 90px;

}

@keyframes fadeHighlight {
  0%   { background-color: #d4edda !important; }
  100% { background-color: transparent !important; }
}
</style>
